import { PrimeNG } from 'primeng/config';

/**
 * Configuração de localização em português brasileiro para PrimeNG
 */
export function setPrimeNGLocale(config: PrimeNG): void {
	config.setTranslation({
		startsWith: 'Começa com',
		contains: 'Contém',
		notContains: 'Não contém',
		endsWith: 'Termina com',
		equals: 'Igual a',
		notEquals: 'Diferente de',
		noFilter: 'Sem Filtro',
		lt: 'Menor que',
		lte: 'Menor ou igual a',
		gt: 'Maior que',
		gte: 'Maior ou igual a',
		is: 'É',
		isNot: 'Não é',
		before: 'Antes',
		after: 'Depois',
		dateIs: 'Data é',
		dateIsNot: 'Data não é',
		dateBefore: 'Data antes de',
		dateAfter: 'Data depois de',
		clear: 'Limpar',
		apply: 'Aplicar',
		matchAll: 'Corresponder Todos',
		matchAny: 'Corresponder Qualquer',
		addRule: 'Adicionar Regra',
		removeRule: 'Remover Regra',
		accept: 'Sim',
		reject: 'Não',
		choose: 'Escolher',
		upload: 'Enviar',
		cancel: 'Cancelar',
		dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
		dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
		dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
		monthNames: [
			'Janeiro',
			'Fevereiro',
			'Março',
			'Abril',
			'Maio',
			'Junho',
			'Julho',
			'Agosto',
			'Setembro',
			'Outubro',
			'Novembro',
			'Dezembro',
		],
		monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
		dateFormat: 'dd/mm/yy',
		firstDayOfWeek: 0,
		today: 'Hoje',
		weekHeader: 'Sem',
		weak: 'Fraca',
		medium: 'Média',
		strong: 'Forte',
		passwordPrompt: 'Digite uma senha',
		emptyMessage: 'Nenhum resultado encontrado',
		emptyFilterMessage: 'Nenhum resultado encontrado',
		searchMessage: '{0} resultados disponíveis',
		selectionMessage: '{0} itens selecionados',
		emptySelectionMessage: 'Nenhum item selecionado',
		emptySearchMessage: 'Nenhum resultado encontrado',
		aria: {
			trueLabel: 'Verdadeiro',
			falseLabel: 'Falso',
			nullLabel: 'Não Selecionado',
			star: '1 estrela',
			stars: '{star} estrelas',
			selectAll: 'Todos os itens selecionados',
			unselectAll: 'Todos os itens desmarcados',
			close: 'Fechar',
			previous: 'Anterior',
			next: 'Próximo',
			navigation: 'Navegação',
			scrollTop: 'Rolar para o Topo',
			moveTop: 'Mover para o Topo',
			moveUp: 'Mover para Cima',
			moveDown: 'Mover para Baixo',
			moveBottom: 'Mover para o Final',
			moveToTarget: 'Mover para o Destino',
			moveToSource: 'Mover para a Origem',
			moveAllToTarget: 'Mover Todos para o Destino',
			moveAllToSource: 'Mover Todos para a Origem',
			pageLabel: 'Página {page}',
			firstPageLabel: 'Primeira Página',
			lastPageLabel: 'Última Página',
			nextPageLabel: 'Próxima Página',
			previousPageLabel: 'Página Anterior',
			rowsPerPageLabel: 'Linhas por página',
			jumpToPageDropdownLabel: 'Ir para a Página',
			jumpToPageInputLabel: 'Ir para a Página',
			selectRow: 'Linha Selecionada',
			unselectRow: 'Linha Desmarcada',
			expandRow: 'Linha Expandida',
			collapseRow: 'Linha Recolhida',
			showFilterMenu: 'Mostrar Menu de Filtro',
			hideFilterMenu: 'Ocultar Menu de Filtro',
			filterOperator: 'Operador de Filtro',
			filterConstraint: 'Restrição de Filtro',
			editRow: 'Editar Linha',
			saveEdit: 'Salvar Edição',
			cancelEdit: 'Cancelar Edição',
			listView: 'Visualização em Lista',
			gridView: 'Visualização em Grade',
			slide: 'Deslizar',
			slideNumber: '{slideNumber}',
			zoomImage: 'Ampliar Imagem',
			zoomIn: 'Mais Zoom',
			zoomOut: 'Menos Zoom',
			rotateRight: 'Girar para a Direita',
			rotateLeft: 'Girar para a Esquerda',
		},
	});
}
